'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { serializeSidebarCollapsedPreference } from './sidebar-preference';
type SidebarPreferenceContextValue = {
  collapsed: boolean;
  persistCollapsed: (collapsed: boolean) => void;
};
const SidebarPreferenceContext = createContext<SidebarPreferenceContextValue | null>(null);
type SidebarPreferenceProviderProps = {
  children: React.ReactNode;
  initialCollapsed: boolean;
};
export function SidebarPreferenceProvider(t0) {
  const $ = _c(6);
  const {
    children,
    initialCollapsed
  } = t0;
  const [collapsed, setCollapsed] = useState(initialCollapsed);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = nextCollapsed => {
      try {
        document.cookie = serializeSidebarCollapsedPreference(nextCollapsed, window.location.protocol === "https:");
      } catch {}
      setCollapsed(nextCollapsed);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const persistCollapsed = t1;
  let t2;
  if ($[1] !== collapsed) {
    t2 = {
      collapsed,
      persistCollapsed
    };
    $[1] = collapsed;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const value = t2;
  let t3;
  if ($[3] !== children || $[4] !== value) {
    t3 = <SidebarPreferenceContext.Provider value={value}>{children}</SidebarPreferenceContext.Provider>;
    $[3] = children;
    $[4] = value;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export function useSidebarPreference() {
  const context = useContext(SidebarPreferenceContext);
  if (context == null) {
    throw new Error("useSidebarPreference must be used within SidebarPreferenceProvider");
  }
  return context;
}